const Parse = global.Parse;

const get = (identifierId) => {
    const query = new Parse.Query('AlternateIdentifier')
        .include(['taxonomy', 'system']);

    return {
        type: 'GET_ALTERNATE_IDENTIFIER',
        meta: { identifierId },
        payload: query.get(identifierId)
    };
};

const list = (filters = {}) => {
    const query = new Parse.Query('AlternateIdentifier')
        .include(['taxonomy', 'system']);
    
    if (filters.taxonomy) {
        query.equalTo('taxonomy', filters.taxonomy);
    }

    return {
        type: 'LIST_ALTERNATE_IDENTIFIERS',
        meta: { filters },
        payload: query.find()
    };
};

const listByTaxonomy = (taxonomyId) => {
    const query = new Parse.Query('AlternateIdentifier')
        .include(['system'])
        .equalTo('taxonomy', {
            __type: 'Pointer',
            className: 'Taxonomy',
            objectId: taxonomyId
        });

    return {
        type: 'LIST_ALTERNATE_IDENTIFIERS_BY_TAXONOMY',
        meta: { taxonomyId },
        payload: query.find()
    };
};

const save = (alternateIdentifier) => {
    return {
        type: 'SAVE_ALTERNATE_IDENTIFIER',
        payload: (async () => {
            let identifierToSave;
            
            if (alternateIdentifier.objectId) {
                const query = new Parse.Query('AlternateIdentifier');
                identifierToSave = await query.get(alternateIdentifier.objectId);
            } else {
                identifierToSave = new Parse.Object('AlternateIdentifier');
            }
            
            identifierToSave.set('taxonomy', {
                __type: 'Pointer',
                className: 'Taxonomy',
                objectId: alternateIdentifier.taxonomy
            });
            
            identifierToSave.set('system', {
                __type: 'Pointer',
                className: 'TaxonomySystem',
                objectId: alternateIdentifier.system
            });
            
            identifierToSave.set('identifier', alternateIdentifier.identifier);
            identifierToSave.set('primary', alternateIdentifier.primary || false);

            return identifierToSave.save();
        })()
    };
};

const deleteIdentifier = (identifierId) => {
    return {
        type: 'DELETE_ALTERNATE_IDENTIFIER',
        payload: (async () => {
            const query = new Parse.Query('AlternateIdentifier');
            const identifierToDelete = await query.get(identifierId);
            await identifierToDelete.destroy();
            return { id: identifierId };
        })()
    };
};

const deleteIdentifiers = (identifierIds) => {
    return {
        type: 'DELETE_ALTERNATE_IDENTIFIERS',
        payload: Promise.all(identifierIds.map(async (identifierId) => {
            const query = new Parse.Query('AlternateIdentifier');
            const identifierToDelete = await query.get(identifierId);
            await identifierToDelete.destroy();
            return identifierId;
        }))
    };
};

export default {
    get,
    list,
    listByTaxonomy,
    save,
    deleteIdentifier,
    deleteIdentifiers
};